'use client';

import { FunctionComponent, ReactNode } from 'react';

export interface PaymentDetailRowProps
{
    label: string;
    value: ReactNode;
    isMultiline?: boolean;
}

/**
 * Component: Common detail row for displaying payment information.
 */
const PaymentDetailRow: FunctionComponent<PaymentDetailRowProps> = (props) =>
{
    /** Render */
    return (
        <div className="detail-row mb-2 text-start">
            <strong>{props.label}:</strong>
            {props.isMultiline ? (
                <p className="ms-2 mb-0">{props.value}</p>
            ) : (
                <span className="ms-2">{props.value}</span>
            )}
        </div>
    );
}

export default PaymentDetailRow;